import { render, staticRenderFns } from "./IntelligenceSetupBanner.vue?vue&type=template&id=cff44d3c&scoped=true"
import script from "./IntelligenceSetupBanner.vue?vue&type=script&lang=js"
export * from "./IntelligenceSetupBanner.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceSetupBanner.vue?vue&type=style&index=0&id=cff44d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff44d3c",
  null
  
)

export default component.exports